import { getMainRoleDisplayName } from '@/globals/typescript/utils/roleUtils'
import { LabAdminUser as _LabAdminUser } from '@team-milva/lab-models/user'

export class LabAdminUser extends _LabAdminUser {
  constructor(params: Partial<_LabAdminUser> = {}) {
    super(params)
  }

  get mainRoleDisplayName(): string {
    return getMainRoleDisplayName(this.mainRole)
  }
}

